import React from 'react';
import ArticleCategoryRowProperties from "./ArticleCategoryRowProperties";
import ViewMedium from "../../../ui_components/MediaView/ViewMedium";
import ArticleCategoryRowMedium from "./ArticleCategoryRowMedium";
import ViewLarge from "../../../ui_components/MediaView/ViewLarge";
import ViewSmall from "../../../ui_components/MediaView/ViewSmall";
import ArticleCategoryRowSmall from "./ArticleCategoryRowSmall";


const ArticleCategoryRow: React.FC<ArticleCategoryRowProperties> = ({
                                                    articleCategory,
                                                    onUpdate
                                                }) => {
    return (
        <>
            <ViewSmall>
                <ArticleCategoryRowSmall onUpdate={onUpdate} articleCategory={articleCategory}/>
            </ViewSmall>
            <ViewMedium>
                <ArticleCategoryRowMedium onUpdate={onUpdate} articleCategory={articleCategory} />
            </ViewMedium>
            <ViewLarge>
                <ArticleCategoryRowMedium onUpdate={onUpdate} articleCategory={articleCategory} />
            </ViewLarge>
        </>
    )
}

export default ArticleCategoryRow;

